import { connect } from 'react-redux'
import { setCamperForm } from 'actions/account/campers'
import { setParentForm } from 'actions/account/parents'
import { setEmergencyContactForm } from 'actions/account/emergencyContacts'
import { setPickupPersonForm } from 'actions/account/pickupPeople'
import { setModal, setErrorMessage } from 'actions/account'

const mapStateToProps = () => ({})
const actions = {
  setCamperForm,
  setParentForm,
  setEmergencyContactForm,
  setPickupPersonForm,
  setErrorMessage,
  setModal
}

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
